import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { UseFormReturn } from 'react-hook-form';
import { AddTestForm, ColumnResource } from 'shared/types';
import EditTestWizardReviewStage from '../EditTestWizardReviewStage/EditTestWizardReviewStage';
import WizardConfigurationStage from './WizardConfigurationStage';
import WizardStage from './WizardStage';

const Wrapper = styled(Flex)`
  height: 100%;
  overflow: auto;
`;

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
  stage: number;
  columnsResourcesData: ColumnResource[];
  testType?: string;
  testSubType?: string;
  resourceName?: string;
  testName?: string;
  originalFormValues: Partial<AddTestForm>;
};

const EditTestWizardStages = ({
  methods,
  stage,
  columnsResourcesData,
  testType,
  testSubType,
  resourceName,
  testName,
  originalFormValues,
}: Props) => (
  <Wrapper>
    <WizardStage $index={1} $selectedIndex={stage}>
      <WizardConfigurationStage
        methods={methods}
        columnsResourcesData={columnsResourcesData}
        editMode
      />
    </WizardStage>

    {stage === 2 && (
      <WizardStage $index={2} $selectedIndex={stage}>
        <EditTestWizardReviewStage
          watch={methods.watch}
          testType={testType}
          testSubType={testSubType}
          testName={testName}
          resourceName={resourceName}
          originalFormValues={originalFormValues}
        />
      </WizardStage>
    )}
  </Wrapper>
);

export default EditTestWizardStages;
